import React from 'react';
import {IDSSelect} from "@inera/ids-react";


/**
 * Component for filtering and sorting test reports.
 * Includes dropdowns for selecting a specific service contract and sort order.
 */
const ReportFilterPanel = ({
  contracts,
  selectedContractFilter,
  setSelectedContractFilter,
  sortOrder,
  setSortOrder
}) => (
  <div className="ids-mt-4 ids-flex" style={{ gap: '1rem', alignItems: 'flex-end' }}>

    {/* Dropdown for filtering by service contract */}
    <IDSSelect
      label="Tjänstekontrakt:"
      value={selectedContractFilter}
      onChange={(e) => setSelectedContractFilter(e.target.value)}
    >
      <option value="Alla">Alla tjänstekontrakt</option>
      {contracts.map((contract, idx) => (
        <option key={idx} value={contract}>{contract}</option>
      ))}
    </IDSSelect>

    {/* Dropdown for selecting sort order by date */}
    <IDSSelect
      label="Sortering:"
      value={sortOrder}
      onChange={(e) => setSortOrder(e.target.value)}
    >
      <option value="desc">Senaste först</option>
      <option value="asc">Äldst först</option>
    </IDSSelect>
  </div>
);

export default ReportFilterPanel;